import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { getNotificationRepository } from "@/infrastructure/di";
import type { NotificationFilterState, NotificationListResponse } from "@/domain";
import { queryKeys } from "../queryKeys";
import { distinctNotificationPages } from "./cache";

const PAGE_SIZE = 10;

export const useNotifications = (filters?: NotificationFilterState, enabled = true) => {
  return useInfiniteQuery<NotificationListResponse>({
    queryKey: queryKeys.notifications.list(filters),
    queryFn: ({ pageParam, signal }) =>
      getNotificationRepository().getNotifications(
        {
          ...filters,
          limit: PAGE_SIZE,
          offset: pageParam as number,
        },
        signal,
      ),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      const loaded = allPages.reduce((count, page) => count + page.notifications.length, 0);
      return loaded < lastPage.total_count ? loaded : undefined;
    },
    select: distinctNotificationPages,
    enabled,
  });
};

export const useNotificationStats = (enabled = true) => {
  return useQuery({
    queryKey: queryKeys.notifications.stats(),
    queryFn: ({ signal }) => getNotificationRepository().getNotificationStats(signal),
    enabled,
  });
};
